/**
 * created by xcc on 2022/4/21
 * 用户管理页面
 */
import React, {Component} from 'react';
import {Table, Modal, Input, Button, Pagination} from "antd";
import {message} from "../../sysManagement/utils/sysManagementUtils";
import {connect} from "react-redux";
import NewUserAdd from "./NewUserAdd";
import {Scrollbars} from "react-custom-scrollbars";
import {
    getAllMediaRole,
    getUserManageListData,
    userManageDel,
    userManageUpGetById
} from "../actions/newUserManagement";
import {uuid} from "../../../utils"
import $ from "jquery";
import BindingSites from "../components/BindingSites";
import BaseComponent from "../../../base/BaseComponent";

const {Search} = Input;
let height = window.innerHeight - 96;

class MediaAdminister extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            size: 10,
            total: 0,
            searchValue: "",
            listData: [],  //列表数据
            addVisible: false,
            addTitle: "",
            mediaRoleList: [],
            hideOnSinglePage: true
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        //用户列表
        this.getUserManageList();
        this.getMediaRole();
        //事件监听
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        window.location.reload();   //重新加载页面，类似f5刷新
    }

    componentWillUnmount() {
        // 一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        window.removeEventListener('resize', this.resize);
    }

    /**
     * 媒体角色
     **/
    getMediaRole() {
        getAllMediaRole({}, (data) => {
            let mediaRoleList = [];
            if (data && data.length > 0) {
                mediaRoleList = data;
            }
            this.setState({
                mediaRoleList
            });
        });
    }

    /**
     * 获取用户管理列表数据
     */
    getUserManageList() {
        let params = {
            page: this.state.page,
            size: this.state.size,
        };
        if (this.state.searchValue) {
            params.queryStr = this.state.searchValue
        }
        getUserManageListData(params, (res) => {
            let listData = [];
            let total = 0;
            let hideOnSinglePage = true;
            if(res && res.data && res.data.length){
                listData = res.data;
                total = res.count;
                hideOnSinglePage = false;
            }
            this.setState({
                listData,
                total,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            })
        })
    }

    /**
     * 渲染
     */
    render() {
        return (
            <div style={{margin: 15}}>
                <div style={{
                    width: "100%",
                    height: height,
                }}>
                    {/*渲染头部*/}
                    {this.renderHeader()}
                    {/*渲染内容*/}
                    {this.renderTable()}
                    {/*渲染新增页面*/}
                    {/*组件重新渲染*/}
                    <div key={uuid()}>
                        <NewUserAdd
                            title={this.state.addTitle}
                            onRef={(c) => this.newUserAdd = c}
                            addVisible={this.state.addVisible}
                            onCancelAdd={() => {
                                this.setState({
                                    addVisible: false
                                })
                            }}
                            getUserManageList={() => {
                                this.getUserManageList();
                            }}
                            mediaRoleList={this.state.mediaRoleList}
                        />
                    </div>
                </div>
                <BindingSites ref={ref=>this.bindingSites=ref}/>
            </div>
        )
    }

    renderHeader() {
        return (
            <div style={{background: 'white', padding: "24px 15px",borderRadius:"5px 5px 0 0"}}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}>
                    <Button style={{marginRight: "20px"}} onClick={() => {
                        this.addNewMediaUser()
                    }} type={"primary"}>
                        新增媒体用户
                    </Button>
                    <Search placeholder={"请输入姓名、账号"} style={{width: 250}}
                            onSearch={(searchValue) => {
                                this.setState({searchValue, page: 1}, () => {
                                    this.getUserManageList()
                                })
                            }}/>
                </div>
            </div>
        )
    }

    renderTable() {
        const columns = [
            {
                title: '姓名',
                key: 'userName',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div className={"userName"} title={record.userName} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>{record.userName}
                            <style>{`.userName .tabList .ant-table-thead > tr > th:first-child, .ant-table-tbody > tr td:first-child{
    padding: 16px 16px 16px 16px;overflow-wrap: break-word;}`}</style>
                        </div>
                    )
                }
            },
            {
                title: '账号',
                dataIndex: 'userAccount',
                key: 'userAccount',
                ellipsis: true,
            },
            {
                title: '媒体角色',
                key: 'mediaRoleNames',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div
                            title={record.mediaRoleNames && record.mediaRoleNames.length > 0 ? record.mediaRoleNames.join(",") : ""}
                            style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{record.mediaRoleNames && record.mediaRoleNames.length > 0 ? record.mediaRoleNames.join(",") : ""}</div>
                    )
                }
            },
            {
                title: '操作',
                key: 'action',
                width: 220,
                render: (text, record) => {
                    return (
                        <div style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer",}}>
                            <span style={{marginRight: 10}}
                                  onClick={() => this.bindingSitesUser(record)}>绑定网站用户</span>
                            <span style={{marginRight: 10}}
                                  onClick={() => this.getById(record)}>修改</span>
                            <span onClick={() => this.delete(record)}>删除</span>
                        </div>
                    )
                }
            }
        ];
        return (
            <div id="table" style={{background: 'white', borderRadius:" 0 0 5px 5px"}}>
                <div style={{boxSizing:"border-box", padding: "0 15px 10px 15px",}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={height - 159}>
                        <Table columns={columns} dataSource={this.state.listData} pagination={false}/>
                    </Scrollbars>
                </div>
                {this.state.listData && this.state.listData.length>0 ? <div style={{
                    padding: "10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e6e6e6",
                    borderRadius: "0 0 5px 5px",}}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationOnChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationOnChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.total}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div> : ""}
                <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #table .ant-table-placeholder{border-bottom: 0;}
                `}</style>
            </div>
        )
    }

    getById(record) {
        userManageUpGetById({id: record.id}, (data) => {
            if (data) {
                this.setState({
                    addVisible: true,
                    addTitle: "修改媒体用户"
                }, () => {
                    this.newUserAdd.getDetail(data);
                })
            }
        })
    }

    delete(record) {
        Modal.confirm({
            title: '确认删除用户？',
            onOk: () => {
                userManageDel({id: record.id}, (data, status) => {
                    if (data) {
                        message.success("删除成功");
                        if (this.state.listData.length === 1) {
                            this.paginationOnChange(this.state.page - 1, this.state.size)
                        } else {
                            this.paginationOnChange(this.state.page, this.state.size)
                        }
                    } else {
                        message.error("删除失败");
                    }
                })
            }
        })
    }

    paginationOnChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getUserManageList();
    }

    addNewMediaUser() {
        this.newUserAdd.revert(); //清空
        this.setState({
            addVisible: true,
            addTitle: "新增媒体用户"
        })
    }

    // 绑定网站弹窗
    bindingSitesUser(record) {
        this.bindingSites.showModal(record);
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(MediaAdminister);